export default {
  CREATE_CHANGE_RENEW: '/econo/thirdLeaseContract/save', // 三方仓库租赁合同-新增/变更/续签
  GET_PAGE_DAT: '/econo/thirdLeaseContract/page', // 分页获取数据
  DELETE_BY_ID: '/econo/thirdLeaseContract/delete', // 删除数据
  GET_DETAIL_DATA_BY_ID: '/econo/thirdLeaseContract/detail', // 根据id获取详情数据
  APPROVAL_CONTRACT: '/econo/thirdLeaseContract/apploval', // 审批
  CLOSE_CONTRACT_BY_ID: '/econo/thirdLeaseContract/close', // 关闭合同
  APPROVAL_SUPERVISE_CONTRACT: '/econo/thirdLeaseContract/apploval', // 审批
  QUERY_SETTLEMENT_LIST: '/financial/payableSettlement/list', //查询应付结算列表
  GET_PAGE: '/econo/thirdLeaseContract/pageExcludeSpace',
};
